export const buildReceiptContentRows = (items = [], allocationRows = []) => {
    const rows = (items || []).map(item => ({
        ...item,
        amount: item.type === 'Sản phẩm' && item.amount_to_pay !== null
            && item.amount_to_pay !== undefined
            ? Number(item.amount_to_pay)
            : item.amount,
        allocated_amount: item.type === 'Sản phẩm'
            ? Number(item.product_allocated_amount || 0)
            : 0,
        refunded_amount: item.type === 'Sản phẩm'
            ? Number(item.product_refunded_amount || 0)
            : 0,
    }));
    const receiptItemIndexes = {};
    const serviceIndexes = {};

    rows.forEach((row, index) => {
        if (row.id) receiptItemIndexes[Number(row.id)] = index;
        if (
            row.customer_service_id &&
            serviceIndexes[Number(row.customer_service_id)] === undefined
        ) {
            serviceIndexes[Number(row.customer_service_id)] = index;
        }
    });

    allocationRows.forEach(allocation => {
        let rowIndex = allocation.receipt_item_id
            ? receiptItemIndexes[Number(allocation.receipt_item_id)]
            : undefined;

        if (rowIndex === undefined && allocation.customer_service_id) {
            rowIndex = serviceIndexes[Number(allocation.customer_service_id)];
        }

        // Allocation lineage không phải nội dung chứng từ và không được dựng thành receipt item giả.
        if (rowIndex === undefined) return;

        rows[rowIndex].allocated_amount += Number(allocation.remaining_amount || 0);
        rows[rowIndex].refunded_amount += Number(allocation.refunded_amount || 0);
    });

    return rows;
};

export const formatConvertedService = service => {
    const code = String(service?.service_code || '').trim();
    const name = String(service?.service_name || '').trim();
    if (!name) return '';
    return code ? `${code}. ${name}` : name;
};
